import React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MGrid from "components/Shared/MGrid.tsx";

const GridCard = (props) => (
    <Card className={`card-unnested profile-card`}>
      <div
        className="grid-card"
        style={{
          minWidth: props.gridCols.map(x => x.width).reduce((a, b) => a + b, 22),
          height: "100%"
        }}
      >
        <MGrid
          headerText={props.headerText}
          columnDefinitions={props.gridCols}
          data={props.data}
          isFetchingData={false}
          displayNumOfItemsFound={props.displayNumOfItemsFound}
          configurationId={props.configurationId}
          onRowClick={props.onRowClick}
          actions={props.actions}
          preferences={props.preferences}
          loadPreference={props.loadPreference}
          savePreference={props.savePreference}
          getMapPinForRow={props.getMapPinForRow}
          getMapToolTipForRow={props.getMapToolTipForRow}
        />
      </div>
    </Card>
  );

  GridCard.defaultProps = {
    displayNumOfItemsFound: false,
  };

  GridCard.propTypes = {
    gridCols: PropTypes.array.isRequired,
    headerText: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    configurationId: PropTypes.string,
    isFetchingData: PropTypes.bool,
    onRowClick: PropTypes.func,
    actions: PropTypes.array,
    displayNumOfItemsFound: PropTypes.bool,
    preferences: PropTypes.object,
    loadPreference: PropTypes.func,
    savePreference: PropTypes.func,
    getMapPinForRow: PropTypes.func,
    getMapToolTipForRow: PropTypes.func,
  };

  export default GridCard;